'use client';

import React from 'react';

import { useNav } from '~/contexts';
import { useUser } from '~/shared/auth/useUser';
import { useResponsive } from '~/shared/hooks';

import { HeaderActions } from '../HeaderActions';
import { LanguageDropdownHeader } from '../LanguageDropdownHeader';
import { UserDropdown } from '../UserDropdown';

const COLLAPSED_SIDEBAR_WIDTH = 72;
const EXPANDED_SIDEBAR_WIDTH = 220;

export function Header() {
  const user = useUser();
  const { isAppMenuOpen } = useNav();
  const { isMobile } = useResponsive({ useOnlyAbiTokens: true });

  let sidebarWidth = 0;
  if (!isMobile) {
    sidebarWidth = isAppMenuOpen ? EXPANDED_SIDEBAR_WIDTH : COLLAPSED_SIDEBAR_WIDTH;
  }

  return (
    <header
      className="sticky top-0 z-1100 flex h-(--header-height) shrink-0 items-center justify-between gap-4 border-b border-b-[#EEEFF2] bg-white px-page-gutter"
      style={{ marginLeft: sidebarWidth }}
    >
      <HeaderActions />

      <div className="flex items-center gap-4">
        {user && <LanguageDropdownHeader currentLanguage={user.language} />}
        {user && <UserDropdown user={user} />}
      </div>
    </header>
  );
}
